'use client'

import { useAiChatStatus, useAiChatUi } from '@/entities/ai-chat'

import cl from './open-chat-button.module.scss'

export const UnreadDecorations = () => {
	const { isOpen } = useAiChatUi()
	const { hasUnreadMessage, unreadMessageLabel } = useAiChatStatus()

	if (isOpen || !hasUnreadMessage) return null

	return (
		<>
			<span className={cl.badge} aria-hidden />
			{unreadMessageLabel ? (
				<span className={cl.tooltip} role="tooltip">
					{unreadMessageLabel}
				</span>
			) : null}
		</>
	)
}
